// Reports browser errors to the backend so the site admin gets an alert email.
// Deduped per message, at most 5 reports per page load.
const seen = new Set();
const MAX_REPORTS = 5;
// "Unexpected token '<'" (stale app file after a re-publish) is handled by public/index.html.
const IGNORE = [/resizeobserver/i, /^script error\.?$/i, /extension:\/\//i, /loading chunk \d+ failed/i,
                /unexpected token\s*'?<'?/i];

function report(message, stack) {
  const msg = String(message || "").slice(0, 1000);
  if (!msg || IGNORE.some((re) => re.test(msg)) || seen.has(msg) || seen.size >= MAX_REPORTS) return;
  seen.add(msg);
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/monitor/client-error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: msg, stack: String(stack || "").slice(0, 4000), url: window.location.pathname }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // never let reporting break the page
  }
}

export function installErrorReporter() {
  if (typeof window === "undefined") return;
  window.addEventListener("error", (e) => report(e.message, e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => report(e.reason?.message || e.reason, e.reason?.stack));
}
